import { useState } from 'react';
import LayerTreeControlPanel from './LayerTreeControlPanel';

const LayerTreeControl = (props) => {
  const [expand, setExpand] = useState(['1']);

  return (
    <LayerTreeControlPanel
      map={props.map}
      layers={props.layers}
      filterItems={props.filterItems}
      layersByUser={props.layersByUser}
      selectedDatasets={props.selectedDatasets}
      getGisService={props.getGisService}
      access_token={props.access_token}
      getItemKey={props.getItemKey}
      opacities={props.opacities}
      layerColors={props.layerColors}
      filter_options={props.filter_options}
      tab={props.tab}
      clipLayer={props.clipLayer}
      setClipLayer={props.setClipLayer}
      selectedClipBoundary={props.selectedClipBoundary}
      setSelectedClipBoundary={props.setSelectedClipBoundary}
      selectedClipSubset={props.selectedClipSubset}
      setSelectedClipSubset={props.setSelectedClipSubset}
      selectedCustomClipKey={props.selectedCustomClipKey}
      setSelectedCustomClipKey={props.setSelectedCustomClipKey}
      clipEnabled={props.clipEnabled}
      setClipEnabled={props.setClipEnabled}
      highlightClip={props.highlightClip}
      setHighlightClip={props.setHighlightClip}
      expand={expand}
      setExpand={setExpand}
    />
  );
};
export default LayerTreeControl;
